/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { realtimeEventsControllerGetRealtimeAuthToken } from "./realtimeEventsControllerGetRealtimeAuthToken";

export function realtimeEventsService() {
  return { realtimeEventsControllerGetRealtimeAuthToken }
}